import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { resolveImg } from "@/lib/api";
import { motion } from "framer-motion";

const SPANS = [
  "md:col-span-2 md:row-span-2",
  "md:col-span-1 md:row-span-1",
  "md:col-span-1 md:row-span-1",
  "md:col-span-1 md:row-span-2",
  "md:col-span-1 md:row-span-1",
  "md:col-span-2 md:row-span-1",
];

export const Gallery = ({ gallery = [] }) => {
  const { t, pick } = useLang();
  if (!gallery.length) return null;

  return (
    <section id="gallery" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-terracotta mb-4">{t("gallery_kicker")}</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight text-ink max-w-2xl">{t("gallery_title")}</h2>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4 mt-12" data-testid="gallery-grid">
          {gallery.slice(0, 8).map((g, i) => (
            <motion.div
              key={g.id}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className={`relative overflow-hidden rounded-2xl group ${SPANS[i % SPANS.length]}`}
            >
              <img
                src={resolveImg(g.image_url)}
                alt={pick(g, "caption")}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              {pick(g, "caption") && (
                <span className="absolute bottom-3 left-4 font-label text-dough text-sm font-medium opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                  {pick(g, "caption")}
                </span>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
